import React from "react";

//
import { Row, Col } from "react-bootstrap";

//
import PageHeader from "../../components/general/PageHeader";
import TopFive from "../../components/alert/TopFive";
import LearnMore from "../../components/general/LearnMore";
import AlertBox from "../../components/alert/AlertBox";
import TelegramQuestion from '../../components/alert/TelegramQuestion'

import Telegram from "../../assets/img/telegram-2.png";

function Alerts() {
  return (
    <div id="alerts">
      <PageHeader title="Alerts Overview" subject="Overview and analytics" />

      <Row>
        <Col sm={12} md={6} lg={4} className="gutter-b">
          <TopFive title="🔥 Trending Coins" type="trending" limit="5" />
        </Col>

        <Col sm={12} md={6} lg={4} className="gutter-b">
          <TopFive
            title="🚀 Biggest Gainners"
            type="biggest-gainers"
            limit="5"
          />
        </Col>

        <Col sm={12} lg={4} className="gutter-b">
          <LearnMore
            title="Want to receive Invalert signals in form of private messages on Telegram?"
            subject="You can receive live notifications of buy/Sell and Volume changes for supported 55 crypto cryptocurrencies to your Telegram account."
            src={Telegram}
            modal={<TelegramQuestion/>}
          />
        </Col>
      </Row>

      <AlertBox />
    </div>
  );
}

export default Alerts;
